export function ScreenshotFrame({
  src,
  alt,
  width,
  height,
  testid,
  caption = "Tampilan asli aplikasi KalkuBisnis",
  eager = false,
}) {
  return (
    <figure data-testid={testid} className="relative">
      <div
        aria-hidden="true"
        className="absolute -inset-3 -z-10 rounded-3xl bg-teal-100/60 blur-xl"
      />
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl shadow-slate-900/10">
        <div className="flex items-center gap-1.5 border-b border-slate-100 bg-slate-50 px-4 py-2.5">
          <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
          <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
          <span className="h-2.5 w-2.5 rounded-full bg-teal-400" />
          <span className="ml-3 rounded-md bg-white px-2.5 py-1 text-[10px] font-medium text-slate-500 ring-1 ring-slate-200">
            app.kalkubisnis.id
          </span>
        </div>
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading={eager ? "eager" : "lazy"}
          fetchpriority={eager ? "high" : "auto"}
          decoding="async"
          className="block h-auto w-full"
        />
      </div>
      {caption && (
        <figcaption className="mt-3 text-center text-xs text-slate-400">{caption}</figcaption>
      )}
    </figure>
  );
}
